package com.essntl.features.proposal.ui.allproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ConfirmProposalPopup(
    isOpen: MutableState<Boolean>,
    onDismissRequest: () -> Unit,
    onEditProposalStatus: () -> Unit,
) {
    if (isOpen.value) {
        Dialog(
            onDismissRequest = onDismissRequest,
        ) {
            ConfirmProposalPopupUI(
                onDismissRequest = onDismissRequest,
                onEditProposalStatus = onEditProposalStatus,
            )
        }
    }
}

@Composable
fun ConfirmProposalPopupUI(
    onDismissRequest: () -> Unit,
    onEditProposalStatus: () -> Unit,
) {
    Card(
        shape = RoundedCornerShape(25.dp),
        modifier = Modifier.width(500.dp),
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
            modifier = Modifier
                .fillMaxWidth()
                .background(color = Color.White),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(color = MaterialTheme.esColorScheme.bgPrimary)
                    .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
            ) {
                Text(
                    text = "Confirm proposal",
                    style = MaterialTheme.esTypography.h3Bold24,
                    color = MaterialTheme.esColorScheme.textPrimary,
                    modifier = Modifier.align(Alignment.CenterStart),
                )

                EsSmallOutlineIconButton(
                    onClick = onDismissRequest,
                    iconRes = EsIcons.Close,
                    modifier = Modifier.align(Alignment.CenterEnd),
                )
            }

            Spacer(Modifier.height(height = 2.5.spacing))

            Text(
                text = "Upon confirming the proposal, " +
                    "an itinerary will be generated. You will no longer be able to edit the proposal.",
                style = MaterialTheme.esTypography.p1Regular16.copy(
                    color = MaterialTheme.esColorScheme.textPrimary,
                ),
                modifier = Modifier.padding(horizontal = 2.5.spacing),
            )

            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(2.5.spacing),
            ) {
                EsLargePrimaryButton(
                    onClick = {
                        onEditProposalStatus()
                        onDismissRequest()
                    },
                    text = "Confirm",
                    enabled = true,
                    modifier = Modifier
                        .weight(1F),
                )
                Spacer(modifier = Modifier.width(width = 1.5.spacing))
                EsLargeSecondaryButton(
                    onClick = {
                        onDismissRequest()
                    },
                    text = "Cancel",
                    enabled = true,
                    modifier = Modifier
                        .weight(1F),
                )
            }
        }
    }
}